var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Collapse", {
    staticClass:
      "green-operation__assessment green-operation__green-building-certificate",
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function () {
          return [
            _c(
              "HKLLeftRight",
              [
                _c("span", { staticClass: "font-bold" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "tenancy.greenOperation.assessments.greenBuildingCertificate.title"
                      )
                    )
                  ),
                ]),
                _vm._v(" "),
                !_vm.isEdit && _vm.canViewPoint
                  ? _c("HKLInputPoints", {
                      attrs: { isEdit: false },
                      model: {
                        value: _vm.points,
                        callback: function ($$v) {
                          _vm.points = $$v
                        },
                        expression: "points",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "div",
              [
                _c(
                  "HKLLeftRight",
                  { staticClass: "green-operation__assessment-title" },
                  [
                    _c("span", { staticClass: "font-bold" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "tenancy.greenOperation.assessments.greenBuildingCertificate.greenBuilding"
                            )
                          ) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.canViewPoint
                      ? _c("HKLInputPoints", {
                          attrs: { isEdit: _vm.isEdit },
                          model: {
                            value: _vm.greenBuildingCertificate.point,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.greenBuildingCertificate,
                                "point",
                                $$v
                              )
                            },
                            expression: "greenBuildingCertificate.point",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.isTenant && _vm.greenBuildingCertificate.value.length === 0
                  ? [
                      _vm._v(
                        "\n        " + _vm._s(_vm.$t("emptyValue")) + "\n      "
                      ),
                    ]
                  : _vm.greenBuildingCertificate.value.length > 0 || _vm.isEdit
                  ? _c("GreenBuildingCertificateTable", {
                      attrs: { dataSource: _vm.greenBuildingCertificate.value },
                    })
                  : _vm._e(),
              ],
              2
            ),
            _vm._v(" "),
            _vm.tableAttrs.dataSource.length > 0
              ? _c(
                  "HKLTable",
                  _vm._b(
                    { staticClass: "cert__doc-table" },
                    "HKLTable",
                    _vm.tableAttrs,
                    false
                  )
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }